import { render } from "./CursoPage.vue?vue&type=template&id=119f4eb1&scoped=true"
import script from "./CursoPage.vue?vue&type=script&lang=js"
export * from "./CursoPage.vue?vue&type=script&lang=js"

import "./CursoPage.vue?vue&type=style&index=0&id=119f4eb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-119f4eb1"]])

export default __exports__